import { useState, useEffect } from 'react';
import useCartState from '../../../hooks/useCartState';

import { Helpers } from '../../../core/src/helpers';

export const getItemLevelCSR = (itemId, csrOverrides) => {
    const { csrItemDiscountsAmt, csrItemDiscounts, csrOrderDiscountApplied, csrOrderDiscountAppliedErrorMsg } =
        csrOverrides || {};
    const discountAmount = (csrItemDiscountsAmt && csrItemDiscountsAmt[itemId]) || 0;
    const discountPercentage = (csrItemDiscounts && csrItemDiscounts[itemId]) || 0;
    if (!csrOverrides) {
        return undefined;
    }
    return {
        discountAmount,
        discountPercentage,
        csrOrderDiscountApplied,
        csrOrderDiscountAppliedErrorMsg,
    };
};

/**
 * Hook to mantain local state for price override
 * @returns {{
 *  discountAmount: number,
 *  discountPercentage: number,
 * }}
 */
export const usePriceOverrideState = (initialAmount = 0, initialPercentage = 0) => {
    const { cartInfo } = useCartState();
    const { cartView } = cartInfo || {};
    const { lastUpdateDate } = cartView || {};
    const [discountAmount, setDiscountAmount] = useState(initialAmount);
    const [discountPercentage, setDiscountPercentage] = useState(initialPercentage);
    const [discField, setDiscField] = useState();
    useEffect(() => {
        setDiscountAmount(initialAmount);
        setDiscountPercentage(initialPercentage);
    }, [initialAmount, initialPercentage]);
    useEffect(() => {
        setDiscountAmount(initialAmount);
        setDiscountPercentage(initialPercentage);
    }, [lastUpdateDate]);

    return {
        discountAmount,
        discountPercentage,
        discField,
        setDiscountAmount: (value, price, appliedDiscountAmount) => {
            setDiscountAmount(value);
            setDiscField('AMT');
            if (price) {
                const amount =
                    Helpers.convertPriceToNumber(price) + Helpers.convertPriceToNumber(appliedDiscountAmount);
                const discountPercentage = Math.round((value / amount) * 100 * 100) / 100;
                setDiscountPercentage(discountPercentage);
            }
        },
        setDiscountPercentage: (value, price, appliedDiscountAmount) => {
            setDiscountPercentage(value);
            setDiscField('PCT');
            if (price) {
                const amount =
                    Helpers.convertPriceToNumber(price) + Helpers.convertPriceToNumber(appliedDiscountAmount);
                const discountAmount = Math.round((value / 100) * amount * 100) / 100;
                setDiscountAmount(discountAmount.toFixed(2));
            }
        },
    };
};
